/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const usePesoEnvase = (id_cultivo) => {
  const token = localStorage.getItem("@Token");
  const [pesoEnvase, setPesoEnvase] = useState([]);
  const getPesoEnvase = async () => {
    try {
      const response = await api.get(
        `api/etiquetas/peso_envase/?id_cultivo=${id_cultivo}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      setPesoEnvase(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPesoEnvase();
  }, [id_cultivo]);

  return { pesoEnvase, getPesoEnvase };
};
